/**
 * ResetPasswordForm.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../../sharedComponents/icons/Icons';

const propTypes = {
    errorText: PropTypes.string,
    signIn: PropTypes.func,
    confirmEmail: PropTypes.func
};

export default class ResetPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: ''
        };

        this.emailTextChange = this.emailTextChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        this.email.focus();
    }

    emailTextChange(e) {
        this.setState({
            email: e.target.value
        });
    }

    submitForm(e) {
        e.preventDefault();

        this.props.confirmEmail({
            email: this.state.email
        });
    }

    render() {
        let error = null;

        if (this.props.errorText) {
            error = (
                <div className="rec-notification-error">
                    <span className="rec-notification-icon">
                        <Icons.IconWarning />
                    </span>
                    <div className="rec-notification-body">
                        <p>{this.props.errorText}</p>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="rec-modal-title">Reset Password</div>
                <p>Enter the email address associated with your account. We&#39;ll send a link a reset your password.</p>
                {error}
                <form onSubmit={this.submitForm}>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-email"
                            className="rec-sr-only">
                            Email Address
                        </label>
                        <input
                            ref={(email) => this.email = email}
                            onChange={(event) => this.emailTextChange(event)}
                            placeholder="Email Address"
                            id="rec-acct-email"
                            className="rec-acct-email" />
                        <div className="form-item-icon-holder">
                            <Icons.IconEmail className="rec-icon-email" />
                        </div>
                    </div>
                    <button
                        className="rec-button-primary"
                        title="Send Reset Link"
                        aria-label="Send Reset Link">
                        Send Reset Link
                    </button>
                </form>
                <div className="rec-acct-modal-footer">
                    <button
                        onClick={this.props.signIn}
                        className="rec-button-link"
                        title="Back to Log In"
                        aria-label="Back to Log In">
                        <Icons.IconChevronLeft className="rec-icon-chevron-left" />
                        Back to Log In
                    </button>
                </div>
            </div>
        );
    }
}

ResetPasswordForm.propTypes = propTypes;
